import { render, staticRenderFns } from "./cModalProductList.vue?vue&type=template&id=bd345fc0&scoped=true"
import script from "./cModalProductList.vue?vue&type=script&lang=js"
export * from "./cModalProductList.vue?vue&type=script&lang=js"
import style0 from "./cModalProductList.vue?vue&type=style&index=0&id=bd345fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd345fc0",
  null
  
)

export default component.exports